<div class="tc-leaderboard__header-section">
  <div class="tc-leaderboard__header-section-heading">
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.myBonuses' | translate }}
  </div>
</div>

<!-- Freshen up bonus -->
<div class="tc-leaderboard__bonus">
  <div
    class="tc-leaderboard__bonus-name"
    [ngClass]="{
      'tc-leaderboard__bonus-name--hover': !!freshenUpModule && freshenUpBonusAvailable
    }"
    (click)="!!freshenUpModule && freshenUpBonusAvailable ? openVideoDialog(freshenUpModule) : null"
  >
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.freshenUp' | translate }}
    <span class="tc-leaderboard__bonus-points"> (20 {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.points' | translate }})</span>
    <img
      *ngIf="!!freshenUpModule && freshenUpBonusAvailable"
      src="assets/icons/play.png"
      title="{{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.startModule' | translate }}"
      class="tc-leaderboard__bonus-start-icon"
    />
  </div>
  <div
    class="tc-leaderboard__bonus-status"
    [ngClass]="{
      'tc-leaderboard__bonus-status--incomplete': !teamUser.bonuses.freshenUp.days.includes(currentChallengeDay)
    }"
  >
    {{
      !teamUser.bonuses.freshenUp.days.includes(currentChallengeDay)
        ? ('STATS.CHALLENGE_LEADERBOARD.bonuses.available' | translate)
        : ('STATS.CHALLENGE_LEADERBOARD.bonuses.completed' | translate)
    }}
  </div>
  <div class="tc-leaderboard__bonus-hint">
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.freshenUpDesc' | translate }}
  </div>
</div>

<!-- Diversity / Variety bonus -->
<div class="tc-leaderboard__bonus">
  <div class="tc-leaderboard__bonus-name">
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.diversity' | translate }}
    <span class="tc-leaderboard__bonus-points"> (40 {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.points' | translate }})</span>
  </div>
  <div
    class="tc-leaderboard__bonus-status"
    [ngClass]="{
      'tc-leaderboard__bonus-status--incomplete': !teamUser.bonuses.diversity.days.includes(currentChallengeDay)
    }"
  >
    {{
      !teamUser.bonuses.diversity.days.includes(currentChallengeDay)
        ? ('STATS.CHALLENGE_LEADERBOARD.bonuses.available' | translate)
        : ('STATS.CHALLENGE_LEADERBOARD.bonuses.completed' | translate)
    }}
  </div>
  <div class="tc-leaderboard__bonus-hint">
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.diversityDesc' | translate }}
  </div>
</div>

<!-- tea time bonus -->
<div class="tc-leaderboard__bonus">
  <div
    class="tc-leaderboard__bonus-name"
    [ngClass]="{
      'tc-leaderboard__bonus-name--hover': !!relaxerModule && teaTimeBonusAvailable
    }"
    (click)="!!relaxerModule && teaTimeBonusAvailable ? openVideoDialog(relaxerModule) : null"
  >
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.teaTime' | translate }}
    <span class="tc-leaderboard__bonus-points">(20 {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.points' | translate }})</span>
    <img
      *ngIf="!!relaxerModule && teaTimeBonusAvailable"
      src="assets/icons/play.png"
      title="{{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.startModule' | translate }}"
      class="tc-leaderboard__bonus-start-icon"
    />
  </div>
  <div
    class="tc-leaderboard__bonus-status"
    [ngClass]="{
      'tc-leaderboard__bonus-status--incomplete': !teamUser.bonuses.teatime.days.includes(currentChallengeDay)
    }"
  >
    {{
      !teamUser.bonuses.teatime.days.includes(currentChallengeDay)
        ? ('STATS.CHALLENGE_LEADERBOARD.bonuses.available' | translate)
        : ('STATS.CHALLENGE_LEADERBOARD.bonuses.completed' | translate)
    }}
  </div>
  <div class="tc-leaderboard__bonus-hint">
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.teaTimeDesc' | translate }}
  </div>
</div>

<!-- Salmagundi / Allrounder bonus -->
<div class="tc-leaderboard__bonus">
  <div class="tc-leaderboard__bonus-name">
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.salmagundi' | translate }}
    <span class="tc-leaderboard__bonus-points"> (300 {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.points' | translate }})</span>
  </div>

  <div
    class="tc-leaderboard__bonus-status"
    [ngClass]="{
      'tc-leaderboard__bonus-status--incomplete': teamUser.bonuses.salmagundi.exerciseIDs.length < 80
    }"
  >
    {{ teamUser.bonuses.salmagundi.exerciseIDs.length >= 80 ? 80 : teamUser.bonuses.salmagundi.exerciseIDs.length }}
    / 80
  </div>
  <div class="tc-leaderboard__bonus-hint">
    {{ 'STATS.CHALLENGE_LEADERBOARD.bonuses.salmagundiDesc' | translate }}
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/challenge-statistics/components/challenge-leaderboard/components/challenge-leaderboard-bonus/challenge-leaderboard-bonus.component.html